import React from "react";
import "../Styles/LearnMoreButton.css";

const LearnMoreButton = ({ onClick }) => {
  return (
    <button className="learn-more-btn" onClick={onClick}>
      Learn More <span>→</span>
    </button>
  );
};

export default LearnMoreButton;
